import { createElement } from "react";

export const ConditionalWrapper = <
  TWrapper extends React.ElementType,
  TWrapperProps extends React.ComponentProps<TWrapper>
>({
  condition,
  wrapperComponent,
  wrapperProps,
  children
}: {
  condition: boolean;
  wrapperComponent: TWrapper;
  wrapperProps?: Omit<TWrapperProps, "children">;
  children: React.ReactNode;
}) =>
  condition ? (
    createElement(wrapperComponent, wrapperProps, children)
  ) : (
    <>{children}</>
  );
